import checkBox from './checkBox.vue'
export default checkBox
